module.exports = __webpack_public_path__ + "static/excursion-359924f7f4866550415f934ac358e94f.jpg";